import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Link } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  listItem: {
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  iconContainer: {
    minWidth: 40,
  },
  icon: {
    color: theme.palette.primary.main,
  },
  primary: {
    fontWeight: 500,
  },
  secondary: {
    fontSize: '0.8rem',
  },
}));

export interface Resource {
  title: string;
  description: string;
  icon: React.ReactNode;
  href: string;
  external?: boolean;
}

interface ResourceCardProps {
  resource: Resource;
}

export const ResourceCard = ({ resource }: ResourceCardProps) => {
  const classes = useStyles();

  return (
    <ListItem
      className={classes.listItem}
      button
      component={Link}
      to={resource.href}
    >
      <ListItemIcon className={classes.iconContainer}>
        {React.cloneElement(resource.icon as React.ReactElement, {
          className: classes.icon,
        })}
      </ListItemIcon>
      <ListItemText
        primary={resource.title}
        secondary={resource.description}
        classes={{
          primary: classes.primary,
          secondary: classes.secondary,
        }}
      />
      {resource.external && (
        <ListItemSecondaryAction>
          <IconButton edge="end" size="small">
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
};
